var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.146447 0.146447C-0.0488156 0.341709 -0.0488155 0.658291 0.146447 0.853553L4.62623 5.33333L0.146447 9.81311C-0.0488151 10.0084 -0.0488151 10.325 0.146447 10.5202C0.341709 10.7155 0.658292 10.7155 0.853554 10.5202L5.68689 5.68689C5.88215 5.49162 5.88215 5.17504 5.68689 4.97978L0.853553 0.146447C0.658291 -0.0488156 0.341709 -0.0488155 0.146447 0.146447Z",
    fill: "#AEB7BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.97982 0.146447C3.78456 0.341709 3.78456 0.658291 3.97982 0.853553L8.4596 5.33333L3.97982 9.81311C3.78456 10.0084 3.78456 10.325 3.97982 10.5202C4.17508 10.7155 4.49167 10.7155 4.68693 10.5202L9.52026 5.68689C9.71552 5.49162 9.71552 5.17504 9.52026 4.97978L4.68693 0.146447C4.49167 -0.0488156 4.17508 -0.0488155 3.97982 0.146447Z",
    fill: "#AEB7BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleRight);
export default __webpack_public_path__ + "static/media/DoubleRight.14b6c18f515a6b240be586ba870ff910.svg";
export { ForwardRef as ReactComponent };